module.exports = __webpack_public_path__ + "img/fb_post.7976457f.jpg";